(() => {
    const isMobile = () => window.innerWidth < 835;

    document.querySelectorAll('.collapsible-toggle').forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            if (!isMobile()) return;

            e.preventDefault();
            const group = toggle.closest('.collapsible-group');
            if (!group) return;

            const isOpen = group.classList.contains('collapsible-group--open');
            group.classList.toggle('collapsible-group--open', !isOpen);
        });
    });
})();
